import { HTTP_STATUS, isApiError } from '@brightlocal/api-client';

/** The template no longer exists for this account: it was deleted (`404`) or isn't the account's (`403`). */
export const isTemplateGoneError = (error: unknown) =>
  isApiError(error) && (error.status === HTTP_STATUS.NOT_FOUND || error.status === HTTP_STATUS.FORBIDDEN);
